export default function Resume() {
    return (
        <div className="mt-10">

        <div class="border-b-4 grid grid-cols-4">
          <div class="m-10 mb-0 text-xl font-bold" >Muhammed Adnaan Ur Rahmaan</div>
          <div class = "m-10 col-start-3 flex justify-end">
            <ul>
              <li>
              <a href='https://linkedin.com/in/muhammed-adnaan-209120320'>linkedin</a>
              </li>
              <li>
              <a href='https://github.com/Muhammed-Adnaan'>Github</a>
              </li>
              </ul></div>
          <div class=" m-10 col-start-4">Phone no: +91 9535328180<br></br>E-Mail: muhammedadnaan33@gmail.com </div>  
        </div>
        <p class=" font-medium text-center border-b-4"><span class="text-sky-700">PROFILE</span><br></br>
                      Recent Computer Science graduate with strong programming skills seeking entry-level software<br></br>
                development position. Proficient in Java, C, Rust and Python. Eager to apply technical knowledge in<br></br>
                developing innovative software solutions. Committed to continuous learning and contributing to<br></br>
                organizational success through efficient coding practices and problem-solving abilities<br></br>
        </p>
        <div class= "border-b-4 grid grid-cols-2">
          <div class="border-r-4">
            <p class="text-center" >
              <span class="text-sky-700 font-medium">EDUCATION</span>
              <div class="grid grid-cols-3 gap-4">
                <div class="col-span-2">
                    <p><span class= "font-bold">B.E in Computer Science and Engineering </span>| CGPA: 7 <br></br>
                    Government Engineering College Mosale Hosahalli, Hassan</p>
                </div>
                <div>
                      <p>Dec 2021-June 2025</p>
                </div>
                <div class="col-span-2">
                    <p><span class= "font-bold">XII (PCMB) 
                     </span>| Percentage: 96% <br></br>
                     Brigade PU College, Hassan</p>
                </div>
                <div>
                      <p>July 2021 </p>
                </div>
                <div class="col-span-2">
                    <p><span class= "font-bold">X (SSLC) 
                     </span>| Percentage: 88%  <br></br>
                     Brilliant Public School, Hassan</p>
                </div>
                <div>
                      <p>April-2019</p>
                </div>
              </div>
            </p>
  
          </div>
          <div>
            <p class="text-center">
              <span class="text-sky-700 font-medium">SKILLS AND ABILITIES</span>
            </p>
            <div class="m-5">
              <span class="font-medium">Programming Languages</span>: Python, Java, Rust, C, C++, PHP, Kotlin, JavaScript (NODE)<br></br>
              <span class="font-medium">Web/App Designing</span> : HTML, CSS, XML,React<br></br>
              <span class="font-medium">Tools & Technologies</span> : Android Studio, Expo, Figma, MySQL, Native-React, Angular, Git, LaTeX, MREN <br></br>
              <span class="font-medium">Soft Skills</span>: Problem Solving, Multilingual (English, Hindi, Kannada, Urdu), Communication, Multitasking,Adaptability, Leadership
            </div>
          </div>
  
        </div>
        <div class="border-b-4">
          <p class="text-center text-sky-700 font-medium ">PROJECT</p>
          <div class="text-center">
                  <span class="font-medium">AduitCode</span> 
                  <ul>
                    <li>• Proposed a project aimed at streamlining the teaching-learning process for both lecturers and students.</li>
                    <li>• Developed a parser system to recognize coding language keywords and reserved words,
            enabling proper code formatting using python.
            </li>          
                    <li>• Designed and implemented a Visual Studio Code-like theme specifically for Python files.
                    </li>          
                    <li>• Created an efficient search system for navigating folders within the editor.
                    </li>          
                  </ul>
            <span class="font-medium">Chat App</span>
            <ul>
              <li>• Developed a web application enabling secure real-time text communication between users.</li>
              <li>• Integrated an admin panel to oversee the app's overall administration and user management.
              </li>
              <li>• Gained hands-on experience with sockets and real-time applications using Node.js
              </li>
              <li>• Ensured the website is fully responsive across tablets and mobile devices.
              </li>
            </ul>
            <span class="font-medium">Travel blog website</span>
            <ul>
              <li>• Designed and built a website to showcase advanced CSS animation skills and foundational
            DBMS integration, enhancing the functionality of a static site.
            </li>
            <li>• Embedded 3D models to provide an immersive experience, illustrating locations as I experienced
            them during my journey.
            </li>
            <li>• Implemented dynamic content management to allow easy updates and scalability of the site.
            </li>
            <li>• Ensured the website is fully responsive across tablets and mobile devices.
            </li>
            </ul>
          </div>
        </div>
        <div class= "">
          <div class= "border-r-4">
            <p class="text-center text-sky-700 font-medium ">CERTIFICATION</p>
            <p class="m-5 text-center">
              <span class="font-medium ">Node JS</span>
              <p>Successfully completed a 6 weeks online certified training
  on Node JS. The training consisted of Introduction to
  Nodejs and Installation Guide, JavaScript Fundamentals,
  JavaScript Asynchronous programming, Node Modules,
  Node Web Application with Express, and Final project -
  Connecting a webapp to MongoDB using AJAX and node
  modules. I scored 93% in the final assessment and was a
  top performer in the training.</p>
              <span class="font-medium">Introduction to Containers w/ Docker, Kubernetes & OpenShift</span>
              <p>Using containers, learn how to move applications quickly across any environment.
  
  Build cloud native applications using Docker, Kubernetes, OpenShift, and Istio.
  
  Describe and leverage Kubernetes architecture to set up and use an entire lifecycle-based container management system.
  
  Create and leverage a YAML deployment file to configure and create resources such as pods, services, replicasets, and others in a declarative way.</p>
            </p>
          </div>
        </div>
      </div>
  
    );
  }
  